  if (!window.DrawerV2Initialized) {
    console.log('[Nutrikorner] card-product-v2.js initialized');
    window.DrawerV2Initialized = true;

    /* ---- FAB helpers ---- */
    function _vFabHide() {
      var f = document.querySelector('.back-to-top');
      if (f) { f.classList.add('hide'); f.style.setProperty('display','none','important'); }
    }
    function _vFabShow() {
      var f = document.querySelector('.back-to-top');
      if (f) f.style.removeProperty('display');
    }

    /* ---- Sync v2d button states from actual hidden input values ---- */
    function _syncV2d(drawer) {
      drawer.querySelectorAll('.v2d-btn-area').forEach(function(area) {
        var inp = area.querySelector('.v2d-hidden-layer .quantity__input');
        var qty = inp ? (parseInt(inp.value, 10) || 0) : 0;
        var addBtn  = area.querySelector('.v2d-add-btn');
        var qtyCtrl = area.querySelector('.v2d-qty-ctrl');
        var cnt     = area.querySelector('.v2d-count');
        if (qty > 0) {
          if (addBtn)  addBtn.style.display  = 'none';
          if (qtyCtrl) qtyCtrl.style.display = 'flex';
          if (cnt)     cnt.textContent       = qty;
        } else {
          if (addBtn)  addBtn.style.display  = '';
          if (qtyCtrl) qtyCtrl.style.display = 'none';
        }
      });
    }

    document.addEventListener('click', function(e) {

      /* ========== OPEN DRAWER ========== */
      var openBtn = e.target.closest('[id^="DrawerOpen-"]');
      if (openBtn) {
        e.preventDefault();
        e.stopPropagation();
        document.querySelectorAll('.card-v2-drawer.is-active').forEach(function(el) { el.classList.remove('is-active'); });
        document.querySelectorAll('.card-v2-drawer-overlay.is-active').forEach(function(el) { el.classList.remove('is-active'); });
        document.querySelectorAll('.is-active-drawer-parent').forEach(function(el) { el.classList.remove('is-active-drawer-parent'); });
        
        var pid     = openBtn.id.replace('DrawerOpen-', '');
        /* Prefer the drawer inside the clicked card: after a grid re-render (sort, filter, sidebar) an
           older copy that was moved to <body> earlier still has the same id and would be picked instead. */
        var ownCard = openBtn.closest('.card-v2');
        var overlay = (ownCard && ownCard.querySelector('[id="VariantDrawerOverlay-' + pid + '"]')) || document.getElementById('VariantDrawerOverlay-' + pid);
        var drawer  = (ownCard && ownCard.querySelector('[id="VariantDrawer-' + pid + '"]')) || document.getElementById('VariantDrawer-' + pid);
        /* Remove stale copies left in <body> by an earlier open, so only this card's current drawer exists. */
        document.querySelectorAll('body > [id="VariantDrawerOverlay-' + pid + '"], body > [id="VariantDrawer-' + pid + '"]').forEach(function (el) {
          if (el !== overlay && el !== drawer) el.remove();
        });
        
        /* Move elements to body to escape parent transforms (e.g., Swiper) and overflow clipping */
        if (overlay) document.body.appendChild(overlay);
        if (drawer)  document.body.appendChild(drawer);

        if (overlay) overlay.classList.add('is-active');
        if (drawer)  { drawer.classList.add('is-active'); setTimeout(function(){ _syncV2d(drawer); }, 80); }
        
        /* Add class to parent card wrapper (kept for backwards compatibility with CSS hover resets) */
        var card = openBtn.closest('.card-v2');
        if (card) {
          card.classList.add('is-active-drawer-parent');
          var p = card.parentElement;
          while (p && p !== document.body) {
            if (p.classList.contains('product-card-main-wrapper') ||
                p.classList.contains('grid__item') ||
                p.classList.contains('tag-filter-product-card') ||
                p.classList.contains('product-card-wrapper') ||
                p.tagName === 'LI') {
              p.classList.add('is-active-drawer-parent');
            }
            p = p.parentElement;
          }
        }

        _vFabHide();
        return;
      }

      /* ========== CLOSE DRAWER ========== */
      var closeEl = e.target.closest('.card-v2-drawer__close, .card-v2-drawer-overlay');
      if (closeEl) {
        document.querySelectorAll('.card-v2-drawer.is-active').forEach(function(el) { el.classList.remove('is-active'); });
        document.querySelectorAll('.card-v2-drawer-overlay.is-active').forEach(function(el) { el.classList.remove('is-active'); });
        document.querySelectorAll('.is-active-drawer-parent').forEach(function(el) { el.classList.remove('is-active-drawer-parent'); });
        _vFabShow();
        return;
      }

      /* ========== v2d ADD ========== */
      var addBtn = e.target.closest('.v2d-add-btn');
      if (addBtn) {
        e.preventDefault();
        if (!localStorage.getItem('userPincode')) {
          /* Close any open variant drawer before opening pincode popup */
          document.querySelectorAll('.card-v2-drawer.is-active').forEach(function(el) { el.classList.remove('is-active'); });
          document.querySelectorAll('.card-v2-drawer-overlay.is-active').forEach(function(el) { el.classList.remove('is-active'); });
          document.querySelectorAll('.is-active-drawer-parent').forEach(function(el) { el.classList.remove('is-active-drawer-parent'); });
          setTimeout(function() {
            if (typeof window.openPincodePopup === 'function') {
              window.openPincodePopup();
            } else {
              var pins = document.querySelectorAll('#header-pincode');
              if (pins.length) pins[0].click();
            }
          }, 150);
          return;
        }
        var area = addBtn.closest('.v2d-btn-area');
        /* Proxy click to hidden ctm_add_btn which triggers quick-add-bulk cart logic */
        var hiddenAdd = area.querySelector('.v2d-hidden-layer .ctm_add_btn');
        if (hiddenAdd) hiddenAdd.click();
        /* Update visual immediately (optimistic) */
        addBtn.style.display = 'none';
        var qc = area.querySelector('.v2d-qty-ctrl');
        var cn = area.querySelector('.v2d-count');
        if (qc) qc.style.display = 'flex';
        if (cn) cn.textContent = '1';
        return;
      }

      /* ========== v2d PLUS ========== */
      var plusBtn = e.target.closest('.v2d-plus');
      if (plusBtn) {
        e.preventDefault();
        var area = plusBtn.closest('.v2d-btn-area');
        var input = area.querySelector('.v2d-hidden-layer .quantity__input');
        var maxLimit = input && input.hasAttribute('max') ? parseInt(input.getAttribute('max'), 10) : Infinity;
        
        var cn = area.querySelector('.v2d-count');
        var curVal = parseInt(cn ? cn.textContent : '0', 10) || 0;
        
        if (curVal < maxLimit) {
          var hp = area.querySelector('.v2d-hidden-layer .quantity__button[name="plus"]');
          if (hp) hp.click();
          if (cn) cn.textContent = curVal + 1;
        }
        return;
      }

      /* ========== v2d MINUS ========== */
      var minusBtn = e.target.closest('.v2d-minus');
      if (minusBtn) {
        e.preventDefault();
        var area = minusBtn.closest('.v2d-btn-area');
        var cn   = area.querySelector('.v2d-count');
        var cur  = parseInt(cn ? cn.textContent : '1', 10) || 1;
        var hm   = area.querySelector('.v2d-hidden-layer .quantity__button[name="minus"]');
        if (hm) hm.click();
        if (cur <= 1) {
          var ab = area.querySelector('.v2d-add-btn');
          var qc = area.querySelector('.v2d-qty-ctrl');
          if (ab) ab.style.display = '';
          if (qc) qc.style.display = 'none';
          if (cn) cn.textContent = '0';
        } else {
          if (cn) cn.textContent = cur - 1;
        }
        return;
      }

    }); /* end click handler */
  }
